import { useEffect, useState } from 'react'
import {
  faReact,
  faPython,
  faGolang,
  faRust,
  faHackerrank,
  faLinux,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
          If you are reading this then I would presume you would like to know a
          little bit about me. Else why else would you click the link labeled
          about me? Jokes aside I am an IT professional with over 10 years
          experience working on very complex global networks in support roles,
          performing break fix corrective actions, routine and emergency change
          activities.
        </p>
        <p>
          I am naturally inquisitive, a deep thinker(I like to think), a true
          believer in perpetually learning new skills/idea and seeking out new
          opportunities to challenge myself. I also have a whimisical sense of
          humor
        </p>
        <p>
          To describe me in a general sense would be to classify me as a GEEK. I
          enjoy the typical nerdy things like video games, comic books,
          tinkering with hardware/software, but I also geek out over sports. So
          you are just as likely to find me researching a tech stack for my next
          project as cheering at a tv when my Niners score a touch down.
        </p>
        <p>
          Outside of that I hope to one day be a world traveler and say I have
          at least touched grass on every continent sans Antartica because I
          have no desire to visit the worlds largest "technical" desert.
        </p>
        </div>

        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faPython} color="#fafa4d" />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faLinux} color="Black" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faHackerrank} color="Green" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faRust} color="#000000" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faGolang} color="#58b8db" />
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
